import { FormControlLabel, FormGroup } from '@mui/material';
import styled from 'styled-components';

export const Label = styled(FormControlLabel)`
  color: black;
`;

export const Container = styled(FormGroup)`
  & .MuiCheckbox-colorSecondary.Mui-checked {
    color: #1976d2;

    &:hover {
      background-color: rgba(64, 224, 208, 0.04);
    }
  }

  & .MuiIconButton-colorSecondary:hover {
    background-color: rgba(64, 224, 208, 0.04) !important;
  }
`;
